"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4 6H2v16h16v-2H4zm18-4H6v16h16zM12 14.5v-9l6 4.5z"
}), 'VideoLibrarySharp');